/**
 * This reducer is used for fetching shipping methods
 */
import {
    GET_SHIP_TO_ADDRESS_REPORT_USAGE,
    GET_INSIDE_SHIP_TO_ADDRESS_SUCCESS,
    GET_INSIDE_SHIP_TO_ADDRESS_FAILURE,
    GET_OUTSIDE_SHIP_TO_ADDRESS_SUCCESS,
    GET_OUTSIDE_SHIP_TO_ADDRESS_FAILURE,
    GET_OUTSIDE_ACCOUNT,
    CLEAR_INSIDE_SHIPPING_ADDRESS,
    CLEAR_OUTSIDE_SHIPPING_ADDRESS,
    SET_USAGE_SURGERY_DETAIL_INSIDE,
    SET_USAGE_SURGERY_DETAIL_OUTSIDE,
    CLEAR_INSIDE_SHIPPING_ADDRESS_WHEN_BILLTO_CLEARED,
    CLEAR_OUTSIDE_SHIPPING_ADDRESS_WHEN_BILLTO_CLEARED,
} from '../action/types';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
const initialState = {
    loading: false,
    statusCode: 0,
    statusMessage: '',
    outsideShipToAddress: {},
    insideShipToAddress: {},
    selectedAccount: '',
    insideSurgeryDetails: {},
    outsideSurgeryDetails: {},
};

const reportShipToAddressReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_SHIP_TO_ADDRESS_REPORT_USAGE:
            return {
                ...state,
                loading: true,
            };
        case GET_INSIDE_SHIP_TO_ADDRESS_SUCCESS:
            return {
                ...state,
                insideShipToAddress: action.isCondensedView
                    ? action.payload?.nonTissueAddress
                        ? {
                              ...action.payload,
                          }
                        : { ...action.payload, nonTissueAddress: [] }
                    : {
                          ...state.insideShipToAddress,
                          ...action.payload,
                      },
                statusCode: action.statusCode,
                statusMessage: action.statusMessage,
                loading: false,
            };
        case GET_OUTSIDE_SHIP_TO_ADDRESS_SUCCESS:
            return {
                ...state,
                outsideShipToAddress: action.isCondensedView
                    ? action.payload?.nonTissueAddress
                        ? {
                              ...action.payload,
                          }
                        : { ...action.payload, nonTissueAddress: [] }
                    : {
                          ...state.outsideShipToAddress,
                          ...action.payload,
                      },
                statusCode: action.statusCode,
                statusMessage: action.statusMessage,
                loading: false,
            };
        case GET_INSIDE_SHIP_TO_ADDRESS_FAILURE:
            return {
                ...state,
                insideShipToAddress: {},
                statusCode: action.statusCode,
                statusMessage: action.statusMessage,
                loading: false,
            };
        case GET_OUTSIDE_SHIP_TO_ADDRESS_FAILURE:
            return {
                ...state,
                outsideShipToAddress: {},
                statusCode: action.statusCode,
                statusMessage: action.statusMessage,
                loading: false,
            };
        case SET_USAGE_SURGERY_DETAIL_INSIDE:
            return {
                ...state,
                insideSurgeryDetails: {
                    ...state.insideSurgeryDetails,
                    ...action.payload,
                },
                loading: false,
            };
        case SET_USAGE_SURGERY_DETAIL_OUTSIDE:
            return {
                ...state,
                outsideSurgeryDetails: {
                    ...state.outsideSurgeryDetails,
                    ...action.payload,
                },
                loading: false,
            };
        case GET_OUTSIDE_ACCOUNT:
            return {
                ...state,
                selectedAccount: action.payload,
                loading: false,
            };
        case CLEAR_INSIDE_SHIPPING_ADDRESS:
            return {
                ...state,
                insideShipToAddress: {},
                insideSurgeryDetails: {},
            };
        case CLEAR_OUTSIDE_SHIPPING_ADDRESS:
            return {
                ...state,
                outsideShipToAddress: {},
                outsideSurgeryDetails: {},
                selectedAccount: '',
            };
        case CLEAR_INSIDE_SHIPPING_ADDRESS_WHEN_BILLTO_CLEARED:
            return {
                ...state,
                insideShipToAddress: {},
            };
        case CLEAR_OUTSIDE_SHIPPING_ADDRESS_WHEN_BILLTO_CLEARED:
            return {
                ...state,
                outsideShipToAddress: {},
            };
        default: {
            return { ...state };
        }
    }
};

export default persistReducer(
    {
        key: 'reportUsageShipToAddressKey',
        storage: storage,
    },
    reportShipToAddressReducer
);
